// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lQ9hp{display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;min-width:195px}@media screen and (min-width:1440px){.lQ9hp{max-width:480px}}.YdHPf{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;margin-bottom:.5rem}.YdHPf:only-child{margin-bottom:0}.P9hLW{font-weight:600}.JnlBF,.P9hLW{font-size:14px;line-height:22px;margin:0}.TKaKq{color:#f3724f;height:25px;margin-right:10px;width:25px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `lQ9hp`,
	"row": `YdHPf`,
	"title": `P9hLW`,
	"message": `JnlBF`,
	"icon": `TKaKq`
};
module.exports = ___CSS_LOADER_EXPORT___;
